<template>
  <div class="reply-item">
    <div class="reply-item-title reply-item-common">
      <span class="reply-item-title-left">
        <img class="publish-avatar" :src="item.publishUserAvatar" >
        {{ item.publishUserName }}

        <span style="margin:0 12px">回复</span>

        <img  v-if="item.replyUserId" class="publish-avatar" :src="item.replyUserAvatar"></img>
        <span v-if="item.replyUserId">
          {{ item.replyUserName }}
        </span>
      </span>
      
      <span>{{ item.createTime }}</span>
    </div>
    <div class="reply-item-content reply-item-common">
      <span class="reply-item-content-text">
        {{ item.content }}
      </span>
      <span class="reply-item-delete" @click="deleteReplay">删除</span>
    </div>
  </div>
</template>

<script>
import { deleteCommentReply } from '@/api/commentManage'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    getReplyDetail: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    deleteReplay () {
      // 确保 row 和 item 已经被定义
      if (!this.row || !this.item) {
        console.error('Row or item is not defined.')
        return
      }
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          const row = this.row
          const params = {
            activityId: row.activityId,
            commentId: row.activityCommentId,
            commentReplyId: this.item.commentReplyId,
            isDelete: row.isDelete
          }
          try {
            await deleteCommentReply(params)
            this.getReplyDetail({ activityCommentId: row.activityCommentId })
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

.reply-item{
    border: 1px solid #e5e5e5;
    box-shadow: 0px 0px 5px 0px #eee inset;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 5px;
    margin-right: 3px;
    .reply-item-title-left{
      display: flex;
      align-items: center;
      .publish-avatar{
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
    
    .reply-item-common{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .reply-item-title{
      margin-bottom: 5px;
    }
    .reply-item-content{
      padding-top: 5px;
      .reply-item-content-text{
        line-height: 1.5;
      }
      .reply-item-delete{
        display: flex;
        flex: 0 0 50px;
        align-items: center;
        justify-content: center;
        color: red;
        cursor: pointer;
        &:hover{
          transform: scale(1.1);
        }
      }
    }
    
  }
</style>